export default {
  GET_ALL_ANONYMITY (state, data) {
    state.all_anonymity = data.data
  }
}
